'use strict';exports.__esModule = true;exports.getVirtualNumberValue = exports.OTHER_OPTION_VALUE = undefined;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _formatPhoneNumber = require('./formatPhoneNumber');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OTHER_OPTION_VALUE = exports.OTHER_OPTION_VALUE = 'other';

var getVirtualNumberValue = exports.getVirtualNumberValue = function getVirtualNumberValue(contacts, virtualNumbers) {
  if (!virtualNumbers || !virtualNumbers.length) {return null;}

  var clearedPhoneNumber = (0, _formatPhoneNumber.clearPhoneNumber)((0, _get2.default)(contacts, 'phone'));
  var isOtherOption = virtualNumbers.every(function (_ref) {var virtual_number = _ref.virtual_number;return virtual_number !== clearedPhoneNumber;});
  return isOtherOption ? OTHER_OPTION_VALUE : clearedPhoneNumber;
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/getVirtualNumberValue.js
// module id = 1301
// module chunks = 0